import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import {
  Button,
  Box,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { AllegatiUploader } from "../../../../../components/Preventivo/allegati_component";
import { getCurrentUser } from "../../../../core/common_functions";
import { useDoorConfigurationBuilderActions } from "../../../../../store/reducers/door_configuration_builder";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";

export const RilievoPage = () => {
  const { base } = useStoreSelector((store) => store);
  const PergolaConfigurationService = useConfigurationsServicePergola();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const dispatcher = useStoreDispatch();
  const currentUser = getCurrentUser(base);
  const { setStepComplete } = useDoorConfigurationBuilderActions();

  const quoteNumber = id ? Number(id) : null;

  const [formData, setFormData] = useState({
    referente: "",
    email: "",
    telefono: "",
    note: "",
  });

  const [errors, setErrors] = useState({
    referente: false,
    email: false,
    telefono: false,
  });

  useEffect(() => {
    if (!id || isNaN(Number(id))) {
      navigate("/configurations");
    }
  }, [id, navigate]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Resetta eventuale errore sul campo
    if (errors[name as keyof typeof errors]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validate = (): boolean => {
    const newErrors = {
      referente: formData.referente.trim() === "",
      email:
        formData.email.trim() === "" ||
        !/\S+@\S+\.\S+/.test(formData.email.trim()),
      telefono: formData.telefono.trim() === "",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const submit = async () => {
    if (!validate()) return;

    if (!quoteNumber) {
      alert("Numero preventivo non disponibile.");
      return;
    }

    const payload = {
      quoteNumber,
      referente: formData.referente.trim(),
      email: formData.email.trim(),
      telefono: formData.telefono.trim(),
      note: formData.note.trim(),
    };

    setIsSubmit(true);

    try {
      await PergolaConfigurationService.sendRilievoPergola(
        currentUser,
        quoteNumber,
        payload
      );
      dispatcher(setStepComplete({ stepSlug: "rilievo", isComplete: true }));
      navigate(`/pergola-configurations/${id}/rilievo_preventivo`);
    } catch (error: any) {
      console.error("Errore invio rilievo:", error);
      alert(
        error?.message ||
          "Errore durante l'invio del rilievo. Verifica i dati e riprova."
      );
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center h-full p-0">
      <div className="col-xl-5 p-0" style={{ overflowY: "auto", height: "90%" }}>
        {/* Dati di contatto */}
        <Box component="div" mt={4}>
          <Typography variant="h6" gutterBottom>
            Dati di contatto
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Referente"
                name="referente"
                value={formData.referente}
                onChange={handleInputChange}
                error={errors.referente}
                helperText={errors.referente ? "Campo obbligatorio" : ""}
                required
                disabled={isSubmit}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                error={errors.email}
                helperText={errors.email ? "Email non valida" : ""}
                required
                disabled={isSubmit}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
                error={errors.telefono}
                helperText={errors.telefono ? "Campo obbligatorio" : ""}
                required
                disabled={isSubmit}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Note"
                name="note"
                multiline
                rows={3}
                value={formData.note}
                onChange={handleInputChange}
                disabled={isSubmit}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Allegati */}
        <Typography variant="h6" gutterBottom mt={4}>
          Allega Rilievo*
        </Typography>
        <AllegatiUploader currentUser={currentUser} quote_id={quoteNumber!} />

        {/* Pulsante invio */}
        <Box
          component="div"
          className="d-flex flex-row-reverse justify-content-between mt-4"
        >
          <Button
            disabled={isSubmit}
            variant="contained"
            className="ps-3 pe-1"
            onClick={submit}
          >
            <span>{isSubmit ? "INVIO IN CORSO..." : "INVIA RILIEVO"}</span>
            <NavigateNextIcon />
          </Button>
        </Box>
      </div>
    </div>
  );
};